<template>    
    <router-view />
</template>